/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAlertData } from "@/@types/Alert";
import { Alert } from "@/components/Modal";
import Store from "@/store";
import CommonStore, { UI_ACTION_STATE } from "@/store/common";
import { UserStore } from "@/store/user";
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { inject, observer } from "mobx-react";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
interface UI_STATE {
  state: "verify" | "verified" | "error";
}
const EmailVerifyPage = inject(
  Store.type.userStore,
  Store.type.commonStore,
)(
  observer((props: any) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const userStore = props.userStore as UserStore;
    const commonStore = props.commonStore as CommonStore;
    const [uiState, setUiState] = React.useState<UI_STATE>({
      state: "verify",
    });
    const { qtoken } = useParams();
    const [token, setToken] = React.useState<string | null>(null);

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [openResendEmail, setOpenResendEmail] = useState(false);
    const [alertData, setAlertData] = useState<undefined | IAlertData>();
    function resendVerificationEmail(e: any): void {
      e.preventDefault();
      if (!email) {
        setEmailError("Please enter your email address.");
        return;
      }
      setOpenResendEmail(false);
      commonStore.setActionState(UI_ACTION_STATE.PLEASE_WAIT);
      userStore
        .resendEmail(email)
        .then(() => {
          commonStore.setActionState(UI_ACTION_STATE.NONE);
          setAlertData({
            message:
              "Verification email sent! Please check your email (it may be in the spam folder).",
            closeMethod: () => {
              setAlertData(undefined);
            },
          });
        })
        .catch((e: any) => {
          commonStore.setActionState(UI_ACTION_STATE.NONE);
          setAlertData({
            message: "Resend verification email failed: " + e.message,
            closeMethod: () => {
              setAlertData(undefined);
            },
          });
        });
    }
    useEffect(() => {
      if (qtoken && qtoken !== token) {
        setToken(qtoken);
        userStore
          .verifyEmail(qtoken)
          .then(() => {
            setUiState({ state: "verified" });
            setTimeout(() => {
              navigate("/sign-in");
            }, 5000);
          })
          .catch((error) => {
            console.error(error);
            setUiState({ state: "error" });
            enqueueSnackbar("Error verifying email", { variant: "error" });
            setToken(null);
          });
      }
    }, [qtoken]);
    return (
      <Container
        maxWidth="lg"
        sx={{
          py: "82px",
          [theme.breakpoints.up("lg")]: { maxWidth: "lg", py: "82px" },
        }}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "50px",
          }}
        >
          <Typography variant="h2">Verify your email</Typography>
          {uiState.state === "verified" && (
            <Typography variant="h5" textAlign="center">
              Successfully verified your email address.
            </Typography>
          )}
          {uiState.state === "verify" && (
            <Typography variant="h5" textAlign="center">
              Verifying your email address...
            </Typography>
          )}
          {uiState.state === "error" && (
            <>
              <Typography variant="h5" textAlign="center">
                Check your email for a link to verify your email address. <br />
                If you didn&rsquo;t receive an email, we will gladly send you
                another.
              </Typography>

              <Stack direction="row" gap="20px" justifyContent="center">
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setOpenResendEmail(true)}
                >
                  Resend email
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate("/sign-in")}
                >
                  Sign in
                </Button>
              </Stack>
            </>
          )}
        </Card>
        <Dialog
          open={openResendEmail}
          onClose={() => setOpenResendEmail(false)}
        >
          <Typography variant="h2">Resend Verification Email</Typography>
          <DialogContent>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              error={!!emailError}
              helperText={emailError}
              sx={{ maxWidth: "380px" }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenResendEmail(false)}
              size="large"
              variant="outlined"
            >
              Close
            </Button>
            <Button
              onClick={resendVerificationEmail}
              size="large"
              variant="contained"
            >
              Resend
            </Button>
          </DialogActions>
        </Dialog>
        {alertData && <Alert alertData={alertData} />}
      </Container>
    );
  }),
);
export default EmailVerifyPage;
